import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

export const Language = () => {
  const { t, i18n } = useTranslation();
  const { locales } = useSelector((state) => state.core);
  const lngs = locales.reduce((acc, locale) => {
    acc[locale.locale] = { nativeName: locale.name };
    return acc;
  }, {});

  return (
    <form className='languageForm desktop'>
      <select
        value={i18n.resolvedLanguage}
        onChange={(event) => i18n.changeLanguage(event.target.value)}
      >
        {Object.keys(lngs).map((lng) => (
          <option key={lng} value={lng}>
            {lng}
          </option>
        ))}
      </select>
    </form>
  );
};
